
<!-- <h4 mat-dialog-title>Reviews</h4>  -->
<app-review [data]="receviedData" [isLoadingReviews]="isLoadingReviews"></app-review>



